import constantFactory from "@gaoding/constant-factory";

export const { FILE_TYPE, FILE_TYPE_LIST, FILE_TYPE_MAP, FILE_TYPE_ITEM_MAP } =
  constantFactory("FILE_TYPE", [
    {
      key: "JPEG",
      label: "JPEG",
      value: "image/jpeg",
    },
    {
      key: "PNG",
      label: "PNG",
      value: "image/png",
    },
    {
      key: "GIF",
      label: "GIF",
      value: "image/gif",
    },
    {
      key: "JPG",
      label: "JPG",
      value: "image/jpg",
    },
    {
      key: "BMP",
      label: "BMP",
      value: "image/bmp",
    },
  ]);
